import { useMutation, useQuery } from '@tanstack/react-query';
import { fetchRequestAdmission, saveRequestAdmission } from 'app/edozvola/cases/request-admission/service/request-admission.service';
import { showToast } from 'app/shared/util/toast.util';
import { queryClient } from 'app/app';
import { RequestAdmissionFormModel } from 'app/edozvola/cases/request-admission/request-admission.model';
import { toast } from 'react-toastify';
import success = toast.success;
import error = toast.error;
import {messages} from "app/config/constants";

export const fetchRequestAdmissionQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['request-admission'],
    queryFn: ({ signal }) =>
      fetchRequestAdmission(idCase),
  });
};

export const updateRequestAdmissionQuery = (uuid: string, resetForm: Function, successCallback: Function) => {
  return useMutation({
    mutationFn: (data: RequestAdmissionFormModel) => saveRequestAdmission(uuid, data),
    onSuccess: (data: RequestAdmissionFormModel) => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: ['request-admission'] });
      resetForm({ values: data });
      successCallback();
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};
